import styled from 'styled-components';

import Lottie from 'lottie-react';

export default styled(Lottie)``;
